import * as Yup from 'yup';

/**
 * Metadata for a file uploaded to Firebase Storage via the admin FileUploader
 * (see apps/admin/src/components/FileUploader). Fields are lenient (nullable)
 * because converters must not reject historical docs: `size` was only added
 * 2026-08, and older entries may miss other fields too.
 */
export const uploadedFileSchema = Yup.object().shape({
  downloadURL: Yup.string().nullable(),
  lastModifiedTS: Yup.number().nullable(),
  name: Yup.string().nullable(),
  ref: Yup.string().nullable(),
  type: Yup.string().nullable(),
  size: Yup.number().nullable(),
});

export default uploadedFileSchema;
